import { TelemetryHistoryEnrichedDTO } from '@eppendorf/vnls-device-service-utils';

export function findTelemValueByType(
  telem?: TelemetryHistoryEnrichedDTO,
): string | undefined {
  if (!telem) {
    return undefined;
  }

  const { valueBoolean, valueDouble, valueString, valueType } = telem;

  switch (valueType) {
    case 'DOUBLE':
      return valueDouble != null ? `${valueDouble}` : undefined;
    case 'BOOLEAN':
      return valueBoolean != null ? `${valueBoolean}` : undefined;
    case 'STRING':
      return valueString ?? undefined;
    default:
      return (
        valueString ??
        (valueDouble != null ? `${valueDouble}` : undefined) ??
        (valueBoolean != null ? `${valueBoolean}` : undefined)
      );
  }
}
